import React from 'react';
import { createStyles, WithStyles, withStyles } from '@material-ui/core';

import { useTranslator } from '../../../i18n/useTranslator';
import { SectionHeader } from '../../SectionHeader';
import { UserForm } from '../../forms/UserForm';
import { Box } from '../../Box';

const styles = () => createStyles({});

type Props = WithStyles<typeof styles>;

const AdminAddUserScreenComponent: React.FunctionComponent<Props> = () => {
  const { t } = useTranslator();

  return (
    <div>
      <SectionHeader title={t('addUser')} />
      <Box>
        <UserForm />
      </Box>
    </div>
  );
};

export const AdminAddUserScreen = withStyles(styles)(AdminAddUserScreenComponent);
